// Type på kjente steder (settings/quickPickups): utsalg (masser hentes her) eller mottak (masser kjøres hit).
// Steder uten type, eller med ukjent verdi, regnes som utsalg.

export const locationKind = loc => (loc?.kind === 'receiver' ? 'receiver' : 'supplier');

export const isReceiver = loc => locationKind(loc) === 'receiver';

// flow: 'in' (levering av masser) gir utsalgene, 'out' (bortkjøring) gir mottakene.
export function placesForFlow(locations, flow) {
  const list = Array.isArray(locations) ? locations : [];
  return list.filter(l => (flow === 'out' ? isReceiver(l) : !isReceiver(l)));
}
